import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Idea } from '../../types';

const UPDATE_IDEA = gql`
  mutation UpdateIdea($input: IdeaUpdateInput!) {
    ideaUpdate(input: $input) {
      ... on IdeaMutationSuccess {
        success
        message
        idea {
          id
          content {
            text
          }
        }
      }
      ... on CoreWebAppCommonError {
        message
        code
        error
      }
    }
  }
`;

export const useEditIdea = () => {
  const [
    executeUpdateIdea,
    {
      data: updateIdeaData,
      error: updateIdeaError,
      loading: updateIdeaLoading,
    },
  ] = useMutation(UPDATE_IDEA, {});

  const updateIdea = useCallback((idea: Idea) => {
    executeUpdateIdea({
      variables: {
        input: idea,
      },
    });
  }, []);

  return { updateIdea, updateIdeaData, updateIdeaError, updateIdeaLoading };
};
